<template>
    <div id="app" :class="{'pb100':showMenue}">
        <base-nav ref="nav" v-if="showMenue"></base-nav>
        <keep-alive >
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>

        <FirstShop :firstDialog="firstDialog" @hiddenFirstDialog="firstDialog = false"></FirstShop>
    </div>
</template>

<script>
    import BaseNav from '@components/Root.vue';
    import FirstShop from '@components/First_in_shop';

    export default {
        data() {
            return {
                showMenue:false,      //是否显示底部菜单
                is_wxjs: true,       //是否选择默认微信配置
                is_init: true,       //是否初始化

                firstDialog: false
            }
        },
        components: {
            BaseNav,
            FirstShop
        },
        name: 'app',
        watch: {
            // 如果路由有变化，会再次执行该方法
            '$route': 'isLinkChange'
        },
        created() {
            let that = this;

            window.App = new tools.vue();

            window.App.$on('wxConfig', function (type) {
                that.is_wxjs = type;
            });

            window.App.$on('title', function (name) {
                document.title = name;
            });

            /*
                **混合 （请认真查看使用方法 https://vuefe.cn/v2/guide/mixins.html）
                **注意同名钩子函数将混合为一个数组，因此都将被调用。且先调用混合对象的钩子
                **
            */
            tools.vue.mixin({
                /* 全局方法 */
                methods: {
                    islogin:function(url,callback,query){
                        var that= this;
                        if(tools.cache.get('is_login')){
                            if(callback){
                                callback(true);
                            }else{
                                if(url == '/chat'){
                                    if(window.sessionStorage.getItem('is_meine') == 1){
                                        return H.$toast('自己不能联系自己哦！');
                                    }else{
                                        that.openWin(url,query)
                                    }
                                }
                                that.openWin(url,query)
                            }
                        }else{
                            that.openWin('/root_login')
                            // H.$confirm(function(){
                            //     let callbackUrl = location.href;
                            //     // 授权地址和所带参数
                            //     let url = window.config.api.url + '/api/wechat/oauths' +
                            //     '?callback=' + (escape(callbackUrl)) +
                            //     '&token=' + window.localStorage.getItem('Authorization') +
                            //     '&type=mp';
                            //     window.location.href = url;
                            // },null,'请您先 登录','温馨提示','取消','去登录');
                        }
                    },
                    /* 默认图片过滤 */
                    thumbnail: function (val, size) {
                        return !val ? app.defaultImg() : val + (!size ? '' : size);
                    },

                    /* 跳转 */
                    toUrl: function (url, val) {
                        tools.router.push({ path: url, query: val });
                    },
                  
                    /* 打开页面 */
                    openWin: function (url, val ,type) {
                        if(!type){
                            tools.router.push({ path: url, query: val });
                        }else{
                            tools.router.replace({ path: url, query: val });
                        }
                    },
                      /* 打开页面 */
                    openWin2: function (url, val ,type) {
                        if(!type){
                            tools.router.push({ path: url, query: val });
                        }else{
                            tools.router.replace({ path: url, query: val });
                        }
                        // if(val.refresh){
                        //     setTimeout(() => {
                        //         history.go(0)
                        //     }, 650);
                        // }
                        if(val == undefined || JSON.stringify(val) === '{}' || JSON.stringify(val) === '[]'){
                            return
                        }
                         if(val && val.refresh == true){
                            window.sessionStorage.setItem('refresh',true)
                         }
                       
                    },
                    /* 返回 */
                    back: function () {
                        tools.router.back();
                    },

                    /* 查看大图 */
                    seeImg: function (imgUrl, arr) {
                        let imgArr = arr;
                        if (arr === undefined) {
                            imgArr = [imgUrl];
                        }
                        app.seeImg(imgUrl, imgArr);
                    },

                    /* 数据更新  */
                    listRefresh: function(click_page,per_page, oldlist , newlist){
                        // click_page 改变的页数(就自己算你点的页数！)  per_page 每页多少条数据 ， oldlist旧数据 ， newlist新小段数据
                        // let ol = JSON.parse(JSON.stringify(oldlist));
                        if(click_page == 1){return newlist}
                        // let length = (click_page)*per_page ;
                        // if((oldlist.length % per_page != 0) &&  (Math.ceil(oldlist.length / per_page )== click_page)){
                        //     // 如果旧数据的长度/每页多少条数据等于获取数据页数 而且 点击的是最后一页数据
                        //     length = oldlist.length;
                        // }

                        oldlist.splice((click_page-1)*per_page, per_page, ...newlist);
                        return oldlist;
                    },  

                },
                /* 全局过滤 */
                filters: {
                    /* 默认图片过滤 */
                    thumbnail: function (val, size) {
                        return !val ? app.defaultImg() : val + (!size ? '' : size);
                    },

                    /* 时间转换 */
                    timeTran: function (value) {
                        return !value ? '-' : tools.date('Y-m-d H:i:s', value);
                    },

                    /* 倒计时 小时-分钟-秒 */
                    countDownTime: function (value) {
                        // return !value ? '-' : tools.date('Y-m-d H:i:s', value);
                        var theTime = parseInt(value);// 需要转换的时间秒 
                        var theTime1 = 0;// 分 
                        var theTime2 = 0;// 小时 
                        var theTime3 = 0;// 天
                        if(theTime > 60) { 
                        theTime1 = parseInt(theTime/60); 
                        theTime = parseInt(theTime%60); 
                        if(theTime1 > 60) { 
                        theTime2 = parseInt(theTime1/60); 
                        theTime1 = parseInt(theTime1%60); 
                        // if(theTime2 > 24){
                        //     //大于24小时
                        //     theTime3 = parseInt(theTime2/24);
                        //     theTime2 = parseInt(theTime2%24);
                        // }
                        } 
                        } 
                        var result = '';
                        if(theTime > 0){
                        result = ""+parseInt(theTime)+"秒";
                        }
                        if(theTime1 > 0) { 
                        result = ""+parseInt(theTime1)+"分"+result; 
                        } 
                        if(theTime2 > 0) { 
                        result = ""+parseInt(theTime2)+"小时"+result; 
                        } 
                        // if(theTime3 > 0) { 
                        // result = ""+parseInt(theTime3)+"天"+result; 
                        // }
                        return result; 
                    },

                    /* 时间转换 */
                    timeTranYMD: function (value) {
                        return !value ? '-' : tools.date('Y-m-d', value);
                    },
                    /* 时间转换 */
                    timeTranYMDHI: function (value) {
                        return !value ? '-' : tools.date('Y-m-d H:i', value);
                    },

                    /* 时间转换 */
                    timeTranHM: function (value) {
                        return !value ? '-' : tools.date('Y-m-d H:i', value);
                    },                    

                    /* 自定时间格式转换 */
                    setTimeTran: function (value, type) {
                        return parseInt(value) === 0 ? '-' : tools.date(type, value);
                    },

                    /* 价格转换--保留两位小数 */
                    toFixedPrice: function (value) {
                        return value ? (parseInt(value) / 100).toFixed(2) : '0';
                    },

                    // /* 价格转换 --保留两位小数*/
                    // toPrice: function (value) {
                    //     return value ? (parseInt(value) / 100).toFixed(2) : '0';
                    // },
                    // 价格转换  有小数点就要有两位 没有就返回整数
                    priceFormat:function(value){
                        // return value ? (parseInt(value) / 100) : '0';
                        let price = parseInt(value) / 100 || 0;
                        // 判断是否有小数点
                        let result = (price.toString()).indexOf(".");
                        if(result != -1){
                            // 含小数点
                            return price.toFixed(2);
                        }else{
                            // 整数
                            return price;   
                        }
                        
                    }
                }
            });
            // 编辑器下载附件的方法
            window.attach_download = function (e) {
                e = e || window.event;
                if (app.isWeChat() && app.device().ios) {
                    tools.alert.error('请在浏览器中打开下载');
                    return;
                }
                // window.location.href = e.target.getAttribute('src');
            }
        },
        methods: {
            isLinkChange: function () {
                let that = this;
                // console.log(tools.router)
                // console.log('改变了导航:',this.$route);
                if(that.$route.path == '/'){
                    that.showMenue = true;
                    that.$nextTick(()=>{
                        that.$refs.nav.change(0);
                    })
                }else
                if(that.$route.path == '/root_classify'){
                    that.showMenue = true;
                    that.$nextTick(()=>{
                        that.$refs.nav.change(1);
                    })
                }else
                if(that.$route.path == '/root_cart'){
                    
                    that.showMenue = true;
                    that.$nextTick(()=>{
                        that.$refs.nav.change(2);
                    })
                }else
                if(that.$route.path == '/root_personal'){
                    that.showMenue = true;
                    that.$nextTick(()=>{
                        that.$refs.nav.change(3);
                    })
                }else{
                    that.showMenue = false;
                }
                // 分类筛选的菜单复选
                if(that.$route.path != '/classily_screen'&&that.$route.path != '/goods_detail'&&that.$route.path != '/root_classify'){
                    window.sessionStorage.removeItem('classifyId');
                }


                // 上新搜索
                if(that.$route.path != '/personal_message_new'&&that.$route.path != '/goods_detail'){
                    window.sessionStorage.removeItem('new_p');
                }

                // 选择订单地址
                if(that.$route.path != '/personal_order_confirm' &&that.$route.path != '/personal_address'&&that.$route.path != '/personal_address_edit'&&that.$route.path != '/personal_forGoods_order_confirm'&&that.$route.path != '/allot_order_confirm_order'&&that.$route.path != '/pickupadress' &&that.$route.path != '/consignee' &&that.$route.path != '/consignee_edit' && that.$route.path != '/payer_list' && that.$route.path != '/payer_list_edit' ){
                    tools.cache.del('address_id');
                    tools.cache.del('pickup_id');
                    tools.cache.del('delivery_method');
                }

                // 普通用户首次进分销商店铺弹窗
                if(localStorage.getItem('user')){
                    let userInfo = JSON.parse(localStorage.getItem('user'));
                    let immediatelyJump = window.sessionStorage.getItem("immediatelyJump");
                    if(userInfo.user_type == 1 && userInfo.hasOwnProperty('shop_has_show_vip_gift_prompt') && userInfo.shop_has_show_vip_gift_prompt === 0 && this.$route.path != '/member_goods_list' && immediatelyJump != '/member_goods_list'){
                        that.firstDialog = true;
                        userInfo.shop_has_show_vip_gift_prompt++;
                        localStorage.setItem('user', JSON.stringify(userInfo));
                    }
                }

                let data = {
                    share_url: window.location.origin + (window.sessionStorage.getItem('shop')?'?shop='+window.sessionStorage.getItem('shop'):''),
                    share_title:'来自【美购国际】',
                    share_desc:'全球尖货，一站式海淘供应链',
                    share_img: window.location.origin + '/static/image/logo.png',
                }
                if(window.sessionStorage.getItem('shop_info')){
                    let shop_info = window.sessionStorage.getItem('shop_info');
                    try{
                        shop_info = JSON.parse(shop_info);
                    }catch(e){}
                    // data.share_url = `${location.origin}?shop=${window.sessionStorage.getItem('shop')}`
                    data.share_title = shop_info.shop_name
                    data.share_img = shop_info.headimg
                }
                //微信分享
                that.$nextTick(function () {
                    setTimeout(function () {
                        //ios
                        if (app.device().ios && app.isWeChat() && that.is_wxjs) {
                            app.wechatjs.ready({
                                share_url: data.share_url,
                                share_title: data.share_title,
                                share_desc:data.share_desc,
                                share_img: data.share_img
                            });
                        }

                        //安卓
                        if (!app.device().ios && app.isWeChat() && that.is_wxjs) { //判断是否为微信

                            app.wechatjs.config = false;
                            app.wechatjs.share_config = {
                                share_url: data.share_url,
                                share_title: data.share_title,
                                share_desc:data.share_desc,
                                share_img: data.share_img
                            };
                            app.wechatjs.run({
                                api_url: '/api/wechat/js/signatures',
                                ajax_data: {
                                    url: location.href
                                },
                                // debug: true
                            })

                        }

                    }, 500)
                });
            },
            
            /*后台自定义统计*/
            // getPhp: function (id, key) {
            // 	var hm = document.createElement("script"); //创建一个script标签
            // 	hm.setAttribute('id', id);
            // 	// hm.src = "https://unicom.collect.han-zi.cn/js.php?ak=" + key;
            // 	hm.src = "http://10.1.1.11:8099/js.php?ak=" + key;
            // 	var s = document.getElementsByTagName("script")[0]; //找到html页面中的第一个script,以便往它之前插入一个script标签
            // 	s.parentNode.insertBefore(hm, s);
            // },
            /* 打开页面 */
            openWin: function (url, val ,type) {
                if(!type){
                    tools.router.push({ path: url, query: val });
                }else{
                    tools.router.replace({ path: url, query: val });
                }

                if(val && val.refresh == true){
                    window.sessionStorage.setItem('refresh',true)
                }
            },
        },
        mounted() {
            let that = this;
            // that.getPhp('midautum', 'XA8vj2mDCbMk6Bae');
                if(tools.url.params('is_go_auth')){
                    tools.cache.set('is_go_auth',tools.url.params('is_go_auth'));
                }

            // ydui UI
            if (localStorage.getItem('PULLREFRESH-TIP') == undefined) {
                localStorage.setItem('PULLREFRESH-TIP', 1); //防止下拉刷新组件弹出提示
            }

            
            tools.router.afterEach((to, from, next) => {
                // 需要keepalive的页面,统一处理 
                let k_path= [
                    '/already_allot_order',             /*已配置订单*/
                    '/mine_cloud_warehouse',            /*我的云仓列表*/
                    '/build_warehouse',                 /*建仓专区*/
                    '/personal_goods_manage_goods',     /*商品管理*/
                    '/personal_message_new',            /*上新*/
                    '/index_search',                   /*搜索商品*/
                    '/personal_goods_manage_add',     /*添加商品*/
                    '/middle_good_lists',             /*商品列表*/
                    '/full_reduction_lists',             /*满减列表*/
                    '/classily_screen',               /*分类商品*/
                    '/root_message',                  /*消息商城*/
                    '/personal_customer',             /*客户管理*/
                    '/personal_customerOrder_lists',  /*客户订单*/
                    '/personal_order_lists',          /*我的订单*/
                    '/tow',                           /*其他页面*/     
                    '/personal_address',              /*地址管理*/     
                    '/personal_collect',              /*我的收藏*/     
                    '/personal_aftersale_list',       /*售后订单*/     
                    '/root_classify',                   /*分类*/     
                    '/edit_picture_text',              /*水印分享页*/     
                    '/personal_business_school',        /*商家学堂*/     
                    '/personal_forGoods_lists',        /*求货中心*/     
                    '/personal_forGoods_edit',        /*添加商品信息*/     
                    '/personal_forGoods_order_lists',    /*求货列表*/     
                    '/root_cart',                      /*购物车*/     
                    '/member_goods_list',              /*会员礼包商品列表*/     
                    '/'
                ]

                to.meta.keepAlive = k_path.indexOf(to.path) != -1 ;

                if (that.is_init) {
                    that.is_init = false;
                    that.$nextTick(function () {
                        setTimeout(function () {
                            //ios
                            if (app.device().ios && that.is_wxjs) {
                                app.wechatjs.config = false;
                                app.wechatjs.share_config = {
                                    share_url: window.location.origin + (window.sessionStorage.getItem('shop')?'?shop='+window.sessionStorage.getItem('shop'):''),
                                    share_title: '来自【美购国际】',
                                    share_desc:'全球尖货，一站式海淘供应链',
                                    share_img: window.location.origin + '/static/image/logo.png',
                                };
                                
                                app.wechatjs.run({
                                    api_url: '/api/wechat/js/signatures',
                                    ajax_data: {
                                        url: tools.cache.get('initUrl')
                                    }
                                })
                            }
                        }, 500);
                    });
                }
            })

        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    @import '~sass/common/tool';
    @import '~sass/common/base';
    @import '~sass/middle_eject';
    #app{
        height: 100%;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
    }
    .downwarp-progress{
        animation: none!important;
        -webkit-animation: none!important;
        transition: none!important;
        border: 0!important;

        img{
            width:100%;
        }
    }
    .hanzi-loading-box{
        position: fixed;
        height: 100%;
        width: 100%;
        z-index: 10001;
        top: 0;
        left: 0;
        transform: translate3d(0,0,10000);
        -webkit-transform: translate3d(0,0,10000);
        .hanzi-loading{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            -webkit-transform: translate(-50%,-50%);
            width: pxTorem(188px);
            height: pxTorem(188px);
            z-index: 10;
            background-color: #fff;
            justify-content: center;
            border-radius: pxTorem(10px);
            // background-color: rgba(255,255,255,0.3);
            box-shadow: 0 4px 8px rgba(0,0,0,0.2);
            .loading-img{
                margin: 0 auto;
                width: pxTorem(120px);
                height: pxTorem(120px);
                img{
                    width: 100%;
                }
            }
            .loading-text{
                margin-top: pxTorem(20px);
                text-align: center;
                color: #333333;
                font-size: pxTorem(28px);
            }
        }
    }
    .mint-indicator,.mint-toast{
        z-index: 10000;
        transform: translate3d(0,0,100);
        -webkit-transform: translate3d(0,0,100);
    }
</style>


// WEBPACK FOOTER //
// App.vue?5ab0d555